export default __webpack_public_path__ + "static/media/video.96591cf7.mp4";